import { useParentChild } from '../context/ParentChildContext';
import { getActiveRole } from '../utils/auth';

/** When active role is PARENT, returns the selected child id; otherwise null (student self). */
export function usePortalStudentId() {
    const role = getActiveRole();
    const { childStudentId } = useParentChild();
    return role === 'PARENT' ? childStudentId : null;
}

export function useIsParentViewingChild() {
    return getActiveRole() === 'PARENT';
}
